// frontend/src/routes/AdminRoute.jsx
import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getMe } from "../services/authService";

export default function AdminRoute({ children }) {
  const [user, setUser] = useState(undefined);
  const location = useLocation();

  useEffect(() => {
    getMe()
      .then((u) => setUser(u))
      .catch(() => setUser(null));
  }, []);

  // まだ getMe の応答を待っている間は何も描画しない
  if (user === undefined) {
    return null;
  }

  // ログインしていなければログインページへ
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // role が admin でなければホームへ
  if (user.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  // admin なら子要素を描画
  return children;
}